/* eslint-disable no-plusplus */
/* eslint-disable no-bitwise */
const hashCode = str => Array.from(str)
  .reduce((s, c) => Math.imul(31, s) + c.charCodeAt(0) | 0, 0);

export default hashCode;
